module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "chap-title",
    attrs: {
      "id": "pagev"
    }
  }, [_vm._v("List of Maps")]), _vm._v(" "), _c('p', {
    staticClass: "foot1"
  }), _c('p', {
    staticClass: "map"
  }, [_vm._v("1. The operations of 1191 and 1194")]), _vm._v(" "), _c('p', {
    staticClass: "map"
  }, [_vm._v("2. The operations against the Tatars in 1196")]), _vm._v(" "), _c('p', {
    staticClass: "map"
  }, [_vm._v("3. Various events from 1196 to 1199")]), _vm._v(" "), _c('p', {
    staticClass: "map"
  }, [_vm._v("4. The attacks on the Naimans in 1199 (first part), 1206, and 1208")]), _vm._v(" "), _c('p', {
    staticClass: "map"
  }, [_vm._v("5. The second part of the 1199 campaign")]), _vm._v(" "), _c('p', {
    staticClass: "map"
  }, [_vm._v("6. The operations against Tayici’ut in 1200")]), _vm._v(" "), _c('p', {
    staticClass: "map"
  }, [_vm._v("7. The operations in East Mongolia 1201 and 1202")]), _vm._v(" "), _c('p', {
    staticClass: "map"
  }, [_vm._v("8. The Köyiten campaign in 1202–1203")]), _vm._v(" "), _c('p', {
    staticClass: "map"
  }, [_vm._v("9. The confrontation with To’oril in 1203")]), _vm._v(" "), _c('p', {
    staticClass: "map"
  }, [_vm._v("10. The defeat of the Naimans in 1204–1205")]), _vm._v(" "), _c('p', {
    staticClass: "map"
  }, [_vm._v("11. The invasion of Xia in 1209–1210")]), _vm._v(" "), _c('p', {
    staticClass: "map"
  }, [_vm._v("12. The first attack on the Jin in 1211–1212")]), _vm._v(" "), _c('p', {
    staticClass: "map"
  }, [_vm._v("13. The continued operations against the Jin in 1212 and 1213–1214")]), _vm._v(" "), _c('p', {
    staticClass: "map"
  }, [_vm._v("14. The first campaigns in the Western region 1216–1220")]), _vm._v(" "), _c('p', {
    staticClass: "map"
  }, [_vm._v("15. The advance to the Sindhu River 1221")]), _vm._v(" "), _c('p', {
    staticClass: "map"
  }, [_vm._v("16. Circling the Caspian Sea I, 1220–1222")]), _vm._v(" "), _c('p', {
    staticClass: "map"
  }, [_vm._v("17. Circling the Caspian Sea II, 1222–1224")]), _vm._v(" "), _c('p', {
    staticClass: "map"
  }, [_vm._v("18. The final confrontation with Xia 1226–1228")]), _vm._v(" "), _c('p', {
    staticClass: "map"
  }, [_vm._v("19. The operations in central China 1230–1231")]), _vm._v(" "), _c('p', {
    staticClass: "map"
  }, [_vm._v("20. The assault on Song Hanzhong 1231–1232")]), _vm._v(" "), _c('p', {
    staticClass: "map"
  }, [_vm._v("21. The Sanfeng campaign 1232")]), _vm._v(" "), _c('p', {
    staticClass: "map"
  }, [_vm._v("22. The final operations against Jin 1232–1234")]), _vm._v(" "), _c('p', {
    staticClass: "map"
  }, [_vm._v("23. The Song attempt to recover Kaifeng and Luoyang in 1234")]), _vm._v(" "), _c('p', {
    staticClass: "map"
  }, [_vm._v("24. The conquest of the Volga Bulgars, Rus, Kipchaks, and other tribes 1236–1240")]), _vm._v(" "), _c('p', {
    staticClass: "map"
  }, [_vm._v("25. The invasion of Central Europe 1241")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-19ca08b2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/04_List_of_Maps.vue
// module id = 66
// module chunks = 0